/* La segunda foto de cada tarjeta (la del cambio al pasar el cursor) se queda
   sin descargar en celular. Solo se activa en aparatos con puntero real, y ahi
   se carga cuando la tarjeta se acerca a la pantalla. */
(function () {
  if (!window.matchMedia || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;

  var pendientes = document.querySelectorAll('.card__img-b[data-src]');
  if (!pendientes.length) return;

  function encender(img) {
    if (!img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
    delete img.dataset.srcset;
  }

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(pendientes, encender);
    return;
  }

  var vigia = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      encender(e.target);
      vigia.unobserve(e.target);
    });
  }, { rootMargin: '300px 0px' });

  Array.prototype.forEach.call(pendientes, function (img) { vigia.observe(img); });
})();
